module.exports = __webpack_public_path__ + "static/media/sqsSa_sm7.9f40b109.png";